export const WEBHOOK_AUTH_TYPE = {
  PUBLIC: 'public',
  BASIC: 'basic',
  HEADER: 'header',
  QUERY: 'query',
} as const;

export type WebhookAuthType =
  (typeof WEBHOOK_AUTH_TYPE)[keyof typeof WEBHOOK_AUTH_TYPE];

export interface IWebhookStaticConfig {
  static_config: string[];
}

export interface IWebhookConfig {
  config_id: string;
  partner_id: string;
  url: string;
  created_at: string;
  updated_at: string;
  [payload: string]: string | boolean;
}

export interface IWebhookConfigUpsert {
  url: string;
  [payload: string]: string | boolean;
}

export interface IErrorNotif {
  notif_id: string;
  partner_id: string;
  email: string;
  created_at: string;
  updated_at: string;
}

export interface IErrorNotifUpsert {
  email: string;
}
